"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var React = require("react");
var SVGPanZoom = require("svg-pan-zoom");
var ReactDOM = require("react-dom");
var Rx_1 = require("rxjs/Rx");
var _ = require("lodash");
var PanZoom = (function (_super) {
    __extends(PanZoom, _super);
    function PanZoom(props) {
        var _this = _super.call(this, props) || this;
        _this.destroy = function () {
            if (!_this.panZoom)
                return;
            _this.panZoom.destroy();
        };
        _this.init = function (diagram, onReady, showControls) {
            _this.destroy(); // Destroy the diagram first in case there is one
            var node = ReactDOM.findDOMNode(diagram);
            SVGPanZoom(node, {
                viewportSelector: '.svg-pan-zoom_viewport',
                controlIconsEnabled: showControls,
                fit: true,
                center: true,
                minZoom: 0.1,
                maxZoom: 20.0,
                zoomEnabled: false,
                customEventsHandler: {
                    init: function (options) {
                        _this.panZoom = options.instance;
                        _this.isUpdating = new Rx_1.BehaviorSubject(false);
                        _this.isUpdating$ = _this.isUpdating.asObservable();
                        onReady(_this);
                    },
                    haltEventListeners: [],
                    destroy: function (_) {
                    }
                },
                beforeZoom: function (oldZoom, newZoom) {
                    _this.isUpdating.next(true);
                    return true;
                },
                beforePan: function (oldPan, newPan) {
                    _this.isUpdating.next(true);
                    return true;
                },
                // This event is fired after the transformation matrix is applied
                // See: https://github.com/ariutta/svg-pan-zoom/issues/121#issuecomment-252393381
                // So set isUpdating to false here
                onUpdatedCTM: function (newCTM) { return _this.isUpdating.next(false); }
            });
        };
        _this.getSizes = function () {
            return _this.panZoom.getSizes();
        };
        _this.getPan = function () {
            return _this.panZoom.getPan();
        };
        _this.zoom = function (zoom_perc) {
            _this.panZoom.zoom(zoom_perc);
        };
        _this.pan = function (coordinates) {
            _this.panZoom.pan(coordinates);
        };
        _this.zoomIn = function () {
            _this.panZoom.zoomIn();
        };
        _this.zoomOut = function () {
            _this.panZoom.zoomOut();
        };
        _this.resetPan = function () {
            _this.panZoom.resetPan();
        };
        _this.resetZoom = function () {
            _this.panZoom.resetZoom();
        };
        _this.reset = function () {
            _this.panZoom.reset();
        };
        return _this;
    }
    PanZoom.prototype.componentWillReceiveProps = function (nextProps, nextState) {
        var prevProps = this.props;
        if (_.isEqual(nextProps.diagram, prevProps.diagram))
            return;
        this.init(nextProps.diagram, nextProps.onReady, nextProps.showPanZoomControls);
    };
    PanZoom.prototype.componentDidMount = function () {
        var _a = this.props, diagram = _a.diagram, onReady = _a.onReady, showPanZoomControls = _a.showPanZoomControls;
        if (!diagram)
            return;
        this.init(diagram, onReady, showPanZoomControls);
    };
    PanZoom.prototype.render = function () {
        // Can put custom Kaavio controls here
        // TODO: Make custom Kaavio PanZoom controls
        return null;
    };
    return PanZoom;
}(React.Component));
exports.PanZoom = PanZoom;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/Kaavio/components/PanZoom.tsx
// module id = 685
// module chunks = 0